"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTypography = void 0;
const bam_1 = __importDefault(require("./typographies/bam"));
const relic_1 = __importDefault(require("./typographies/relic"));
const tickethead_1 = __importDefault(require("./typographies/tickethead"));
const branding_1 = require("./branding");
/**
 * Get typography definition based on branding
 * @param branding
 * @returns
 */
const getTypography = (branding) => {
    switch (branding) {
        case branding_1.BrandingType.RELIC:
            return relic_1.default;
        case branding_1.BrandingType.TICKETHEAD:
            return tickethead_1.default;
        default:
            return bam_1.default;
    }
};
exports.getTypography = getTypography;
//# sourceMappingURL=typography.js.map